import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { WindowType, IFile } from '@typescript/index';
import SectionTitle from '@features/layout/components/SectionTitle/SectionTitle';
import DescriptionsSection from '@features/instructions/sections/GroupList/components/DescriptionsSection/DescriptionsSection';
import stylesDes from '@features/instructions/sections/GroupList/InstructionList.styles';
import getFileListData from '@features/instructions/api';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import { getLanguage } from '@utils/misc';
import { URL_FILE_LIST } from '@config/index';
type PropsType = {
  windowType: WindowType;
};
const GroupSection = ({
  windowType
}: PropsType) => {
  const [fileList, setFileList] = useState<void | [string, IFile[]][]>([]);
  const getUniqueFileList = (filesList: IFile[]): IFile[] => {
    const uniqueFileList: IFile[] = [];
    if (Array.isArray(filesList)) {
      const filesName: Record<string, boolean> = {};
      const l = filesList.length;
      for (let i = 0; i < l; i += 1) {
        const fileName = filesList[i]?.file ? filesList[i].file : null;
        if (fileName && !filesName[fileName]) {
          filesName[fileName] = true;
          uniqueFileList.push(filesList[i]);
        }
      }
    }
    return uniqueFileList;
  };
  const mergeFilesListData = (firstListData: [string, IFile[]][], secondListData: [string, IFile[]][]): [string, IFile[]][] => {
    const uniqueList: Record<string, IFile[]> = {};
    const pushData = (data: [string, IFile[]][]) => {
      data.forEach(files => {
        if (Array.isArray(files[1])) {
          if (files[0] in uniqueList) uniqueList[files[0]] = uniqueList[files[0]].concat(getUniqueFileList(files[1]));else uniqueList[files[0]] = [...getUniqueFileList(files[1])];
        }
      });
    };
    pushData(firstListData);
    pushData(secondListData);
    return Object.keys(uniqueList).map(key => [key, uniqueList[key]]);
  };
  const getAllFileListData = async (url: string, firstListData: [string, IFile[]][], getProductFiles = false): Promise<[string, IFile[]][]> => {
    const data = await getFileListData(url, getProductFiles);
    if (firstListData && data) {
      const newFileList = mergeFilesListData(firstListData, data);
      setFileList(newFileList);
      return newFileList;
    }
    return [];
  };
  const {
    t
  } = useTranslation('layouts');
  const router = useRouter();
  const locale = getLanguage(router.locale);
  const url = `${URL_FILE_LIST}${locale}`;
  useEffect(() => {
    (async () => {
      const data = await getAllFileListData(url, [], true);
      await getAllFileListData(url, data);
    })();
  }, []);
  return <ErrorBoundary>
      <section sx={stylesDes.section}>
        <div sx={stylesDes.instructionListContainer} data-cy="instructionList">
          <SectionTitle title={t('instructionTitle')} />
          <DescriptionsSection items={fileList} windowType={windowType} />
        </div>
      </section>
    </ErrorBoundary>;
};
export default GroupSection;